import { SidebarProvider, useSidebar } from "@/components/ui/sidebar"
import { AppSidebar } from "./Sidebar"
import { Toaster } from "@/components/ui/sonner"
import AppBar from "./AppBar"
import { useLocation } from "react-router-dom"

export default function Layout({ children }: { children: React.ReactNode }) {
    return (
        <SidebarProvider>
            <LayoutContent>{children}</LayoutContent>
        </SidebarProvider>
    )
}

function LayoutContent({ children }: { children: React.ReactNode }) {
  const { open } = useSidebar();
  const {pathname} = useLocation()

  return (
    <>
      <AppSidebar />
      <div className={`${open ? "md:max-w-[calc(100%-255px)] delay-200" : "md:max-w-[calc(100%-50px)] duration-200"}  w-full`}>
        {pathname !== "/" && <AppBar />}
        {children}
        <Toaster />
      </div>
    </>
  );
}